module.exports = __webpack_public_path__ + "assets/img/for-landowners.9067382a.jpg";